import type { IntakeStatus, StaffRole } from './types';

export const PDF_GENERATION_ROLES = ['administrator', 'attorney', 'intake_staff'] as const satisfies readonly StaffRole[];

export function canGeneratePdf(role: StaffRole, status: IntakeStatus): boolean {
	return status !== 'archived' && PDF_GENERATION_ROLES.some((allowedRole) => allowedRole === role);
}
